import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-ae",
  "use": "icon-flag-ae-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-ae\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 128h341.333333v768H0z\" fill=\"#CB1125\" p-id=\"14069\" /><path d=\"M341.333333 128h682.666667v256H341.333333z\" fill=\"#009800\" p-id=\"14070\" /><path d=\"M341.333333 384h682.666667v256H341.333333z\" fill=\"#FFFFFF\" p-id=\"14071\" /><path d=\"M341.333333 640h682.666667v256H341.333333z\" fill=\"#000000\" p-id=\"14072\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-ae.svg
// module id = rbYN
// module chunks = 24